export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "Absolutne": "",
        "Adres": "",
        "Adres email": "",
        "Ai": "",
        "Aktualna karta": "",
        "Aktualne selektory dla których wyświetlane i edytowane są style": "",
        "Aktywne": "",
        "Angielski": "",
        "Animacje": "",
        "Anuluj": "Cancel",
        "Arkusz styli": "",
        "Arkusze styli": "",
        "Auto": "",
        "Automatyczna": "",
        "Automatyczne odtwarzanie": "",
        "Bez limitu": "",
        "Biblioteka": "",
        "Blok": "",
        "Blok nie został usunięty": "",
        "Blok został usunięty": "",
        "Blok został zaktualizowany": "",
        "Blok został zapisany": "",
        "Blur": "",
        "Błąd podczas dodawania urządzenia": "",
        "Błędna szerokość": "",
        "brak": "",
        "Brak": "",
        "Brak animacji": "",
        "Brak limitu": "",
        "Cały tekst małą literą": "",
        "Cały tekst wielką literą": "",
        "Checkbox": "",
        "Cień": "",
        "Cofnij": "",
        "CSS": "",
        "Cytat": "",
        "Czas trwania": "",
        "Czas trwania (ms)": "",
        "Czas trwania zmiany styli (transition)": "",
        "Czcionka": "",
        "Czcionki": "",
        "Czy na pewno chcesz usunąć to urządzenie?": "",
        "Dekoracja": "",
        "Do lewej": "",
        "Do prawej": "",
        "Dodaj": "Add",
        "Dodaj klasę": "",
        "Dodaj kolejną klasę": "",
        "Dodaj kolejną opcję": "",
        "Dodaj kolejny arkusz styli": "",
        "Dodaj kolejny skrypt": "",
        "Dodaj kolor": "",
        "Dodaj niestandardowe urządzenie": "",
        "Dodaj nowy element listy": "",
        "Dodaj nowy slajd": "",
        "Dodaj szablon": "",
        "Dodatkowy element": "",
        "Dolny": "",
        "Domyślny": "",
        "Dostępne klasy": "",
        "Duplikuj": "",
        "Duży komputer": "",
        "Duży telefon": "",
        "Dwie kolumny w wierszu": "",
        "Dziedziczona": "",
        "ease": "",
        "ease-in": "",
        "ease-in-out": "",
        "ease-out": "",
        "Edycja": "",
        "Edytor kodu CSS": "",
        "Edytor kodu HTML": "",
        "Edytor kodu JavaScript": "",
        "Edytor kodu Vue": "",
        "Edytor komponentu React": "",
        "Edytuj": "Edit",
        "Edytuj kod CSS": "",
        "Edytuj kod HTML": "",
        "Edytuj kod JavaScript": "",
        "Edytuj kod Vue": "",
        "Edytuj komponent React": "",
        "Edytuj style": "",
        "Efekty": "",
        "Ekran jest za mały aby korzystać z kreatora stron": "",
        "Element klikalny": "",
        "Element listy": "",
        "Elementy": "",
        "Etykieta": "",
        "Film": "",
        "Film YouTube": "",
        "Filtr": "",
        "Filtr tła": "",
        "Flex": "",
        "Formularz": "",
        "Francuski": "",
        "Funkcja": "",
        "Generuj tekst": "",
        "Globalna klasa": "",
        "Globalne kolory": "",
        "Górny": "",
        "Gradient": "",
        "Gradient promieniowy": "",
        "Grid": "",
        "Gruba": "",
        "Grubość obramowania": "",
        "Grubość tekstu": "",
        "Hover": "",
        "Id inputa": "",
        "Ikona": "",
        "Indeksowanie": "",
        "Indeksuj": "",
        "Indykatory": "",
        "Indykatory poza sliderem": "",
        "Italic": "",
        "Jasność": "",
        "Język": "",
        "Klasy": "",
        "Kliknij aby wybrać tą czcionkę": "",
        "Kod": "",
        "Kod nie może być pusty": "",
        "Kod strony": "",
        "Kod svg": "",
        "Kolor": "",
        "Kolor obramowania": "",
        "Kolor strzałek": "",
        "Kolor tekstu": "",
        "Kolor wypełnienia indykatorów": "",
        "Kolory": "",
        "Kolumna": "",
        "Kolumny": "",
        "Koło": "",
        "Komputer": "",
        "Kontener": "",
        "Kontrast": "",
        "Kontrolki playera": "",
        "Krok": "",
        "Kursor": "",
        "Kwadrat": "",
        "Label": "",
        "Label dla inputa": "",
        "Laptop": "",
        "Lepkie": "",
        "Lewy": "",
        "Lewy dolny": "",
        "Lewy dolny róg": "",
        "Lewy górny": "",
        "Lewy górny róg": "",
        "Liczba widocznych slajdów": "",
        "Liczby dziesiętne": "",
        "Liczby rzymskie": "",
        "linear": "",
        "Linia ciągła": "",
        "Linia kropkowana": "",
        "Linia u dołu tekstu": "",
        "Linia u góry tekstu": "",
        "Linia wycentrowana": "",
        "Link": "",
        "Link do filmu YouTube": "",
        "LinkBox": "",
        "Lista": "",
        "Lista nienumerowana": "",
        "Lista numerowana": "",
        "Maks. szerokość": "",
        "Maks. wysokość": "",
        "Maksymalna szerokość": "",
        "Maksymalna szerokość w px": "",
        "Mały tablet": "",
        "Mały telefon": "",
        "Mapa": "",
        "Margines": "",
        "Menadżer urządzeń": "",
        "Metoda": "",
        "Min. szerokość": "",
        "Min. wysokość": "",
        "Motywy": "",
        "Nagłówek": "",
        "Nagłówek 1": "",
        "Nagłówek 2": "",
        "Nagłówek 3": "",
        "Nagłówek 4": "",
        "Nagłówek 5": "",
        "Narzędzia AI": "",
        "Następny slajd": "",
        "Nawigacja": "",
        "Nazwa": "",
        "Nazwa klasy": "",
        "Nazwa koloru": "",
        "Nazwa koloru jest wymagana": "",
        "Nazwa koloru już istnieje": "",
        "Nazwa musi mieć minimum 2 znaki": "",
        "Nazwa nie może być pusta": "",
        "Nazwa skryptu": "",
        "Nazwa szablonu": "",
        "Nazwa urządzenia": "",
        "Nie indeksuj": "",
        "Nie posiadasz uprawnień aby zapisać komponent": "",
        "Nie posiadasz uprawnień do dodania nowego motywu": "",
        "Nie posiadasz uprawnień do edycji zapisanego komponentu": "",
        "Nie posiadasz uprawnień do usunięcia motywu": "",
        "Nie posiadasz uprawnień do usunięcia zapisanego komponentu": "",
        "Nie powtarzaj": "",
        "Nie udało się pobrać bloków": "",
        "Nie udało się pobrać definicji bloku": "",
        "Nie udało się pobrać szablonów": "",
        "Nie udało się wygenerować tekstu": "",
        "Nie udało się zaktualizować bloku": "",
        "Nie udało się zapisać bloku": "",
        "Nie wyświetlaj": "",
        "Nie zawijaj": "",
        "Niemiecki": "",
        "Nienumerowana": "",
        "Nieparzysty element": "",
        "Nieprawidłowy format koloru": "",
        "Nieruchome": "",
        "Niestandardowe": "",
        "Normalna": "",
        "Nowa karta": "",
        "np. checkbox-1": "",
        "np. https://ideo.pl": "",
        "np. Jan": "",
        "np. Nad przyrwą 13": "",
        "np. radio-1": "",
        "np. Tekst opisowy": "",
        "np. Twoje imie": "",
        "Numerowana": "",
        "Obetnij nadmiar": "",
        "Obramowanie": "",
        "Obrót odcieni": "",
        "Odepnij": "",
        "Odległość między elementami": "",
        "Odległość między slajdami (px)": "",
        "Odległość od dolnej krawędzi": "",
        "Odległość od górnej krawędzi": "",
        "Odległość z lewej strony": "",
        "Odległość z prawej strony": "",
        "Odstęp dookoła elementów": "",
        "Odstęp pomiędzy elementami": "",
        "Odwrócenie": "",
        "Odziedzoczono po": "",
        "Offset x": "",
        "Offset Y": "",
        "Opcje": "",
        "Opis dla open graph": "",
        "Opis strony": "",
        "Opóźnienie (ms)": "",
        "Ostatnie kolory": "",
        "Otwórz": "Open",
        "Padający cień": "",
        "Padding": "",
        "Page builder": "",
        "Page Builder": "",
        "Paragraf": "",
        "Parzysty element": "",
        "Pasek progresu": "",
        "Podaj szerokość w px": "",
        "Podany kod jest niepoprawny, w konsoli znajdują się informacje o błędach": "",
        "Podgląd": "",
        "Podkreślenie": "",
        "Podpowiedź": "",
        "Pogrubienie": "",
        "Pojedyńcza kolumna": "",
        "Pokaż etykietę": "",
        "pokaż więcej...": "",
        "Polski": "",
        "Położenie": "",
        "Pomoc": "",
        "Poprzedni slajd": "",
        "Powiększenie": "",
        "Powrót": "",
        "Powrzarzanie tła": "",
        "Powtarzaj": "",
        "Powtarzaj horyzontalnie": "",
        "Powtarzaj wertykalnie": "",
        "Pozycja": "",
        "Pozycja tła": "",
        "Prawy": "",
        "Prawy dolny": "",
        "Prawy dolny róg": "",
        "Prawy górny": "",
        "Prawy górny róg": "",
        "Prezentacja": "",
        "Prosty": "",
        "Przejdź wyżej": "",
        "Przekierowanie": "",
        "Przekreślenie": "",
        "Przełącz edycję styli klas": "",
        "Przełącz obramowanie": "",
        "Przełącz rozwinięcie": "",
        "Przesunięcie": "",
        "Przesunięcie w dół": "",
        "Przesunięcie w górę": "",
        "Przesunięcie w lewo": "",
        "Przesunięcie w prawo": "",
        "Przeźroczystość": "",
        "Przycisk": "",
        "Przykładowy tekst": "",
        "Przypnij do lewej krawędzi": "",
        "Przypnij do prawej krawędzi": "",
        "Przywróć": "",
        "Radio": "",
        "React": "",
        "Relatywne": "",
        "Resetuj wymiary": "",
        "Rozbudowany": "",
        "Rozbuduj tekst": "",
        "Rozciągnij": "",
        "Rozmiar": "",
        "Rozmiar strzałek": "",
        "Rozmiar tekstu": "",
        "Rozmycie": "",
        "Rozstaw liter": "",
        "Równe odstępy": "",
        "Saturacja": "",
        "Schowaj": "",
        "Sekcja": "",
        "Selektor kolorów": "",
        "SEO": "",
        "Separator": "",
        "Sepia": "",
        "SFC": "",
        "Sformatuj poprawnie nazwę klasy": "",
        "Skala szarości": "",
        "Skrypt": "",
        "Skrypt aktywny": "",
        "Skrypty": "",
        "Slajd": "",
        "Slajder": "",
        "Spread": "",
        "Stan": "",
        "Stan elementu": "",
        "Statyczne": "",
        "Strzałki poza slajderem": "",
        "Styl": "",
        "Styl obramowania": "",
        "Styl tekstu": "",
        "Style": "",
        "Style nie mogą być puste": "",
        "Style tekstu": "",
        "Szablon": "",
        "Szablon aktywny": "",
        "Szablon nie został pobrany": "",
        "Szablon nie został usunięty": "",
        "Szablon nie został zapisany": "",
        "Szablon został usunięty": "",
        "Szablon został zapisany": "",
        "Szerokość": "",
        "Szerokość ekranu (px)": "",
        "Środek dolnej krawędzi": "",
        "Środek górnej krawędzi": "",
        "Środek kontenera": "",
        "Środek lewej krawędzi": "",
        "Środek prawej krawędzi": "",
        "Tablet": "",
        "Target": "",
        "Tekst": "",
        "Tekst alternatywny": "",
        "Telefon": "",
        "Tło": "",
        "Tłumaczenie": "",
        "Transformacja": "",
        "Tryb układu": "",
        "Twoje imie": "",
        "Twój adres email": "",
        "Typ": "",
        "Typ listy": "",
        "Typ nagłówka": "",
        "Typ przycisku": "",
        "Tytuł": "",
        "Tytuł dla open graph": "",
        "Tytuł strony": "",
        "Układ": "",
        "Ułożenie elementów": "",
        "Ułożenie elementów według głównej osi": "",
        "Ułożenie elementów według osi poprzecznej": "",
        "Usuń": "Delete",
        "Usuń urządzenie": "",
        "Utwórz": "",
        "Użyj styli zgodnych z CSS3": "",
        "W pionie": "",
        "W poziomie": "",
        "Warstwy": "",
        "Wartość": "",
        "Wartość koloru jest wymagana": "",
        "Wartość w pikselach": "",
        "Wewnętrzny": "",
        "Widoczność": "",
        "Wielka litera": "",
        "Wiersz": "",
        "Wiersze": "",
        "Własne": "",
        "Własne polecenie": "",
        "Własny blok": "",
        "Własny kod CSS": "",
        "Własny kod HTML": "",
        "Własny kod JavaScript": "",
        "Własny kod React": "",
        "Własny kod Vue": "",
        "Włącz pełny ekran": "",
        "Wpisywanie tekstu": "",
        "Wpisz polecenie": "",
        "Wpisz tutaj cytat": "",
        "Wpisz tutaj swój nagłówek": "",
        "Wpisz tutaj tekst": "",
        "Wprowadź modyfikację": "",
        "Wrapper": "",
        "Wszystko": "",
        "Wybierz czcionki": "",
        "Wycentrowanie": "",
        "Wycisz film": "",
        "Wyczyszczenie formularza formularza": "",
        "Wyczyść": "",
        "Wyczyść formularz": "",
        "Wygenerowany tekst": "",
        "Wygląd listy": "",
        "Wymagany": "",
        "Wymiary dokumentu": "",
        "Wyrównanie do końca": "",
        "Wyrównanie do początku": "",
        "Wyrównanie tekstu": "",
        "Wysokość": "",
        "Wysokość linii": "",
        "Wystąpił błąd podczas zapisywania kodu CSS": "",
        "Wystąpił błąd podczas zapisywania kodu HTML": "",
        "Wystąpił błąd podczas zapisywania kodu JavaScript": "",
        "Wystąpił błąd podczas zapisywania komponentu React": "",
        "Wyszukaj": "",
        "Wyśrodkowanie": "",
        "Wyświetl kod": "",
        "YouTube": "",
        "Zaawansowany": "",
        "Zablokuj": "",
        "Zaktualizuj": "",
        "Zamknij": "",
        "Zanikanie": "",
        "Zaokgrąglenie rogów": "",
        "Zapętlaj": "",
        "Zapisywanie formularza": "",
        "Zapisz": "Save",
        "Zapisz formularz": "",
        "Zarządzaj urządzeniami": "",
        "Zawijaj": "",
        "Zawijanie elementow": "",
        "Zaznacz komponent aby edytować animacje": "",
        "Zaznaczony": "",
        "Zaznaczony tekst": "",
        "Zdjęcie": "",
        "Zdjęcie dla open graph": "",
        "Zewnętrzny": "",
        "Zmień nazwę": "",
        "Zmień rozmiary": "",
        "Zmień wymiary dokumentu": "",
        "Zoom": "",
        "Zwykły przycisk": ""
    }
};
